// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easyPayPayment_bg-gray-100__Mwpft {
  background-color: #f5f5f5 !important;
}

.easyPayPayment_tru-mma-main-wrapper__BFiWH {
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75) !important;
  border: 1px solid #ced4da !important;
}

.easyPayPayment_p-20__vji\\+V {
  padding: 20px !important;
}

.easyPayPayment_p-30__EtL\\+h {
  padding: 30px !important;
}

.easyPayPayment_gfs-24__142lx {
  font-size: 24px !important;
}

.easyPayPayment_gfw-3__L2BU9 {
  font-weight: 300 !important;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_bg-dark__Pyw6T {
  background-color: #414141 !important;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_p-12__3Q-m\\+ {
  padding: 12px !important;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_mb-20__tSzRE {
  margin-bottom: 20px !important;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_tg-ft-26pt__Dkf88 {
  font-size: 26pt;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_tg-ft-20pt__aXoGI {
  font-size: 20pt;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_tg-ft-15pt__-X\\+Aw {
  font-size: 15pt;
}

#easyPayPayment_errorMessage__5RRnI .easyPayPayment_btn-primary__lJJBK {
  background-color: #ffb034 !important;
  border: none !important;
}

@media (min-width: 992px) {
  .easyPayPayment_g-font-size-lg-30__GXHK8, .easyPayPayment_gfs-lg-30__T64cF {
    font-size: 30px !important;
  }
}
.easyPayPayment_text-gray-med__zU0Yn {
  color: #9e9e9e !important;
}

.easyPayPayment_g-font-size-30__HnAsi, .easyPayPayment_gfs-30__NpbLL {
  font-size: 30px !important;
}

.easyPayPayment_bg-gray-300__-QaQA {
  background-color: #9e9e9e !important;
}

.easyPayPayment_py-5__nx7O6 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

@media (min-width: 992px) {
  .easyPayPayment_mt-lg-0__OwUMM {
    margin-top: 0 !important;
  }
}
.easyPayPayment_px-20__C1DQZ {
  padding-right: 20px !important;
}

.easyPayPayment_pl-20__Hza-k, .easyPayPayment_px-20__C1DQZ {
  padding-left: 20px !important;
}

.easyPayPayment_font-italic__Gb1N- {
  font-style: italic !important;
}

.easyPayPayment_g-line-height-1_2__Mv8ik, .easyPayPayment_glh-1_2__RlAzw {
  line-height: 1.2 !important;
}

.easyPayPayment_g-font-size-20__xOMtf, .easyPayPayment_gfs-20__jhBCl {
  font-size: 20px !important;
  line-height: 1.2;
}

.easyPayPayment_gfs-20__jhBCl .easyPayPayment_font-italic__Gb1N- {
  font-style: italic !important;
}

.easyPayPayment_ep-setting-btn__4h9oR {
  text-decoration: none !important;
}

@media (min-width: 768px) {
  .easyPayPayment_p-md-30__7FXIY {
    padding: 30px !important;
  }
}
.easyPayPayment_tru-mma-main-service-box__rVuVk {
  border: 1px solid #6c757d;
}

.easyPayPayment_tru-mma-main-content-box__ecjIk {
  border: 1px solid #6c757d;
}

.easyPayPayment_text-green__ZK-AE {
  color: #73c573 !important;
}

.easyPayPayment_g-font-weight-700__R2coW, .easyPayPayment_gfw-7__YSVVK {
  font-weight: 700 !important;
}

@media (min-width: 768px) {
  .easyPayPayment_g-font-size-md-40__bwY9Z, .easyPayPayment_gfs-md-40__uURVl {
    font-size: 40px !important;
  }
}
.easyPayPayment_g-line-height-1_2__Mv8ik, .easyPayPayment_glh-1_2__RlAzw {
  line-height: 1.2 !important;
}

@media (min-width: 992px) {
  .easyPayPayment_g-font-size-lg-16__Xa\\+SR, .easyPayPayment_gfs-lg-16__59Gor {
    font-size: 16px !important;
  }
}
.easyPayPayment_g-font-size-12__fodcl, .easyPayPayment_gfs-12__z8YoY {
  font-size: 12px !important;
}

.easyPayPayment_mb-20__tSzRE {
  margin-bottom: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Payments/easyPayPayment.module.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ;;AACA;EACI,2DAAA;EACA,oCAAA;AAEJ;;AAAA;EACI,wBAAA;AAGJ;;AADA;EACI,wBAAA;AAIJ;;AAFA;EACI,0BAAA;AAKJ;;AAHA;EACI,2BAAA;AAMJ;;AAHA;EACI,oCAAA;AAMJ;;AAJA;EACI,wBAAA;AAOJ;;AALA;EACI,8BAAA;AAQJ;;AANA;EACI,eAAA;AASJ;;AAPA;EACI,eAAA;AAUJ;;AARA;EACI,eAAA;AAWJ;;AATA;EACI,oCAAA;EACA,uBAAA;AAYJ;;AATA;EACI;IACI,0BAAA;EAYN;AACF;AAVA;EACI,yBAAA;AAYJ;;AATA;EACI,0BAAA;AAYJ;;AAVA;EACI,oCAAA;AAaJ;;AAXA;EACI,2BAAA;EACA,8BAAA;AAcJ;;AAZA;EACI;IACI,wBAAA;EAeN;AACF;AAZA;EACI,8BAAA;AAcJ;;AAZA;EACI,6BAAA;AAeJ;;AAbA;EACI,6BAAA;AAgBJ;;AAdA;EACI,2BAAA;AAiBJ;;AAfA;EACI,0BAAA;EACA,gBAAA;AAkBJ;;AAhBA;EACI,6BAAA;AAmBJ;;AAjBA;EACI,gCAAA;AAoBJ;;AAlBA;EACI;IACI,wBAAA;EAqBN;AACF;AAlBA;EACI,yBAAA;AAoBJ;;AAjBA;EACG,yBAAA;AAoBH;;AAjBA;EACI,yBAAA;AAoBJ;;AAlBA;EACI,2BAAA;AAqBJ;;AAnBA;EACI;IACI,0BAAA;EAsBN;AACF;AApBA;EACI,2BAAA;AAsBJ;;AApBA;EACI;IACI,0BAAA;EAuBN;AACF;AArBA;EACI,0BAAA;AAuBJ;;AArBA;EACI,8BAAA;AAwBJ","sourcesContent":[".bg-gray-100 {\n    background-color: #f5f5f5 !important;\n}\n.tru-mma-main-wrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75) !important;\n    border: 1px solid #ced4da !important;\n}\n.p-20 {\n    padding: 20px !important;\n}\n.p-30 {\n    padding: 30px !important;\n}\n.gfs-24 {\n    font-size: 24px !important;\n}\n.gfw-3 {\n    font-weight: 300 !important;\n}\n\n#errorMessage .bg-dark {\n    background-color: #414141 !important;\n}\n#errorMessage .p-12 {\n    padding: 12px !important;\n}\n#errorMessage .mb-20 {\n    margin-bottom: 20px !important;\n}\n#errorMessage .tg-ft-26pt {\n    font-size: 26pt;\n} \n#errorMessage .tg-ft-20pt {\n    font-size: 20pt;\n} \n#errorMessage .tg-ft-15pt {\n    font-size: 15pt;\n} \n#errorMessage .btn-primary {\n    background-color: #ffb034 !important;\n    border: none !important;\n}\n\n@media (min-width: 992px) {\n    .g-font-size-lg-30, .gfs-lg-30 {\n        font-size: 30px !important;\n    }\n}\n.text-gray-med {\n    color: #9e9e9e !important;\n}\n\n.g-font-size-30, .gfs-30 {\n    font-size: 30px !important;\n}\n.bg-gray-300 {\n    background-color: #9e9e9e !important;\n}\n.py-5 {\n    padding-top: 5px !important;\n    padding-bottom: 5px !important;\n}\n@media (min-width: 992px) {\n    .mt-lg-0 {\n        margin-top: 0 !important;\n    }\n}\n\n.px-20 {\n    padding-right: 20px !important;\n}\n.pl-20, .px-20 {\n    padding-left: 20px !important;\n}\n.font-italic {\n    font-style: italic !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.g-font-size-20, .gfs-20 {\n    font-size: 20px !important;\n    line-height: 1.2;\n}\n.gfs-20 .font-italic {\n    font-style: italic !important;\n}\n.ep-setting-btn{\n    text-decoration: none !important;\n}\n@media (min-width: 768px) {\n    .p-md-30 {\n        padding: 30px !important;\n    }\n}\n\n.tru-mma-main-service-box {\n    border: 1px solid #6c757d;\n}\n\n.tru-mma-main-content-box {\n   border: 1px solid #6c757d;\n}\n\n.text-green {\n    color: #73c573 !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-40, .gfs-md-40 {\n        font-size: 40px !important;\n    }\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n    }\n}\n.g-font-size-12, .gfs-12 {\n    font-size: 12px !important;\n}\n.mb-20{\n    margin-bottom: 20px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg-gray-100": `easyPayPayment_bg-gray-100__Mwpft`,
	"tru-mma-main-wrapper": `easyPayPayment_tru-mma-main-wrapper__BFiWH`,
	"p-20": `easyPayPayment_p-20__vji+V`,
	"p-30": `easyPayPayment_p-30__EtL+h`,
	"gfs-24": `easyPayPayment_gfs-24__142lx`,
	"gfw-3": `easyPayPayment_gfw-3__L2BU9`,
	"errorMessage": `easyPayPayment_errorMessage__5RRnI`,
	"bg-dark": `easyPayPayment_bg-dark__Pyw6T`,
	"p-12": `easyPayPayment_p-12__3Q-m+`,
	"mb-20": `easyPayPayment_mb-20__tSzRE`,
	"tg-ft-26pt": `easyPayPayment_tg-ft-26pt__Dkf88`,
	"tg-ft-20pt": `easyPayPayment_tg-ft-20pt__aXoGI`,
	"tg-ft-15pt": `easyPayPayment_tg-ft-15pt__-X+Aw`,
	"btn-primary": `easyPayPayment_btn-primary__lJJBK`,
	"g-font-size-lg-30": `easyPayPayment_g-font-size-lg-30__GXHK8`,
	"gfs-lg-30": `easyPayPayment_gfs-lg-30__T64cF`,
	"text-gray-med": `easyPayPayment_text-gray-med__zU0Yn`,
	"g-font-size-30": `easyPayPayment_g-font-size-30__HnAsi`,
	"gfs-30": `easyPayPayment_gfs-30__NpbLL`,
	"bg-gray-300": `easyPayPayment_bg-gray-300__-QaQA`,
	"py-5": `easyPayPayment_py-5__nx7O6`,
	"mt-lg-0": `easyPayPayment_mt-lg-0__OwUMM`,
	"px-20": `easyPayPayment_px-20__C1DQZ`,
	"pl-20": `easyPayPayment_pl-20__Hza-k`,
	"font-italic": `easyPayPayment_font-italic__Gb1N-`,
	"g-line-height-1_2": `easyPayPayment_g-line-height-1_2__Mv8ik`,
	"glh-1_2": `easyPayPayment_glh-1_2__RlAzw`,
	"g-font-size-20": `easyPayPayment_g-font-size-20__xOMtf`,
	"gfs-20": `easyPayPayment_gfs-20__jhBCl`,
	"ep-setting-btn": `easyPayPayment_ep-setting-btn__4h9oR`,
	"p-md-30": `easyPayPayment_p-md-30__7FXIY`,
	"tru-mma-main-service-box": `easyPayPayment_tru-mma-main-service-box__rVuVk`,
	"tru-mma-main-content-box": `easyPayPayment_tru-mma-main-content-box__ecjIk`,
	"text-green": `easyPayPayment_text-green__ZK-AE`,
	"g-font-weight-700": `easyPayPayment_g-font-weight-700__R2coW`,
	"gfw-7": `easyPayPayment_gfw-7__YSVVK`,
	"g-font-size-md-40": `easyPayPayment_g-font-size-md-40__bwY9Z`,
	"gfs-md-40": `easyPayPayment_gfs-md-40__uURVl`,
	"g-font-size-lg-16": `easyPayPayment_g-font-size-lg-16__Xa+SR`,
	"gfs-lg-16": `easyPayPayment_gfs-lg-16__59Gor`,
	"g-font-size-12": `easyPayPayment_g-font-size-12__fodcl`,
	"gfs-12": `easyPayPayment_gfs-12__z8YoY`
};
export default ___CSS_LOADER_EXPORT___;
